import React from "react";
import {
  Col,
  Dialog,
  FabButton,
  Flex,
  Gap,
  InputField,
  Row,
  Typography,
} from "../../ppui";
import { TbPencil } from "react-icons/tb";
import { OrganizationBx, OrganizationEmDetails } from "../style";
const StatutoryComplianceDetails = () => {
  // Modal
  const [setOpenComplianceModal, setOpenStatutoryComplianceModal] =
    React.useState(false);

  const handleOpenStatutoryComplianceModal = () =>
    setOpenStatutoryComplianceModal(true);
  const handleCloseStatutoryComplianceModal = () =>
    setOpenStatutoryComplianceModal(false);
  // Modal
  return (
    <>
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography mb={"0"} variant="h5">
          Compliance Information
        </Typography>

        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={handleOpenStatutoryComplianceModal}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />

      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            NIC Code
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            346583
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            LIC Code
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            BRD346583754326
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>

      {/*Modal */}
      <Dialog
        title="Compliance Information"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={setOpenComplianceModal}
        onClose={handleCloseStatutoryComplianceModal}
        onSubmit={() => alert("Submitted")}
        separator
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              fullWidth
              label="NIC Code"
              placeholder="Type Here..."
              type="text"
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="LIC Code"
              placeholder="Type Here..."
              type="text"
            />
          </Col>
        </Row>
      </Dialog>
      {/*Modal */}
    </>
  );
};

export default StatutoryComplianceDetails;
